import { Button, Card, Typography } from '@mui/material'
import ModuleHeader from '@/core/components/moduleHeader/ModuleHeader.tsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckDouble } from '@fortawesome/pro-regular-svg-icons'
import NotificationTable from '@/modules/utilities/notification/components/listNotifications/NotificationTable.tsx'
import useNotificationLogic from '@/modules/utilities/notification/hooks/useNotificationLogic.ts'

const NotificationContainer = () => {
  const { handlerMarkAllAsRead, isPending } = useNotificationLogic()
  return (
    <Card elevation={0}>
      <ModuleHeader>
        <Typography variant="h5">Notificaciones</Typography>
        <Button
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faCheckDouble} />}
          loading={isPending}
          onClick={() => handlerMarkAllAsRead()}
        >
          Marcar todas como leidas
        </Button>
      </ModuleHeader>
      <NotificationTable />
    </Card>
  )
}

export default NotificationContainer
